/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.11.17.
 */

import React from "react";
import PropTypes from "prop-types";
import Modal from "./Modal";
import {t} from "../../trans";

class ModalWizard extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        title: PropTypes.string.isRequired,
        backButton: PropTypes.string,
        forwardButton: PropTypes.string,
        backDisabled: PropTypes.bool,
        forwardDisabled: PropTypes.bool,
        onClickBack: PropTypes.func,
        onClickForward: PropTypes.func,
        onClose: PropTypes.func
    };

    static defaultProps = {
        id: "modal",
        backDisabled: false,
        forwardDisabled: false
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    renderBackButton() {
        if (!this.props.backButton || !this.props.onClickBack) return null;
        return (
            <button type="button" className="btn btn-white" onClick={this.props.onClickBack} disabled={this.props.backDisabled}>{this.props.backButton}</button>
        );
    }

    renderForwardButton() {
        if (!this.props.forwardButton || !this.props.onClickForward) return null;
        return (
            <button type="button" className="btn btn-primary" onClick={this.props.onClickForward} disabled={this.props.forwardDisabled}>{this.props.forwardButton}</button>
        );
    }

    render() {
        return (
            <Modal modalClass="inmodal fade" modalAttrib={{"data-backdrop": "static", "data-keyboard": "false"}} id={this.props.id} tabIndex="-1" role="dialog" aria-hidden="true" onClose={this.props.onClose}>
                <Modal.Content>
                    <Modal.Header>
                        <button type="button" className="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span className="sr-only">{t("Close")}</span></button>
                        <h4 className="modal-title">{this.props.title}</h4>
                    </Modal.Header>
                    <Modal.Body>
                        {this.props.children}
                    </Modal.Body>
                    <Modal.Footer>
                        {this.renderBackButton()}
                        {this.renderForwardButton()}
                    </Modal.Footer>
                </Modal.Content>
            </Modal>

        );
    }
}

export default ModalWizard;
